/* @generated */
"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
  return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var props = __getOwnPropSymbols(b), i = 0, n = props.length, prop; i < n; i++) {
      prop = props[i];
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = function(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __export = function(target, all) {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = function(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function")
    for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
      key = keys[i];
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: function(k) {
          return from[k];
        }.bind(null, key), enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
  return to;
};
var __toESM = function(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  );
};
var __toCommonJS = function(mod) {
  return __copyProps(__defProp({}, "__esModule", { value: true }), mod);
};

// ../src/menu/index.ts
var menu_exports = {};
__export(menu_exports, {
  BACKSPACE_KEY: function() {
    return BACKSPACE_KEY;
  },
  DELETE_KEY: function() {
    return DELETE_KEY;
  },
  DOWN_ARROW_KEY: function() {
    return DOWN_ARROW_KEY;
  },
  ENTER_KEY: function() {
    return ENTER_KEY;
  },
  ESC_KEY: function() {
    return ESC_KEY;
  },
  FOCUSABLE_SELECTOR: function() {
    return FOCUSABLE_SELECTOR;
  },
  LAST_SELECTED_INDEX: function() {
    return LAST_SELECTED_INDEX;
  },
  LEFT_ARROW_KEY: function() {
    return LEFT_ARROW_KEY;
  },
  Menu: function() {
    return Menu;
  },
  NONE_SELECTED_INDEX: function() {
    return NONE_SELECTED_INDEX;
  },
  RIGHT_ARROW_KEY: function() {
    return RIGHT_ARROW_KEY;
  },
  SPACEBAR_KEY: function() {
    return SPACEBAR_KEY;
  },
  TAB_KEY: function() {
    return TAB_KEY;
  },
  UP_ARROW_KEY: function() {
    return UP_ARROW_KEY;
  },
  VISUALLY_HIDDEN_CSS: function() {
    return VISUALLY_HIDDEN_CSS;
  },
  buttonContentDataAttributeName: function() {
    return buttonContentDataAttributeName;
  },
  buttonContentDataSelector: function() {
    return buttonContentDataSelector;
  },
  buttonDataAttributeName: function() {
    return buttonDataAttributeName;
  },
  buttonDataSelector: function() {
    return buttonDataSelector;
  },
  iconButtonDataAttributeName: function() {
    return iconButtonDataAttributeName;
  },
  iconButtonDataSelector: function() {
    return iconButtonDataSelector;
  },
  splitButtonDataAttributeName: function() {
    return splitButtonDataAttributeName;
  },
  splitButtonDataSelector: function() {
    return splitButtonDataSelector;
  }
});
module.exports = __toCommonJS(menu_exports);

// ../src/menu/menu.ts
var import_focus_visible2 = require("focus-visible");

// ../src/menu/action_item.tsx
var React7 = __toESM(require("react"));

// ../src/menu/row.tsx
var import_classnames5 = __toESM(require("classnames"));
var React6 = __toESM(require("react"));

// ../src/menu/context.tsx
var React = __toESM(require("react"));
var import_hooks = require("@dropbox/dig-components/hooks");
var defaultValue = {
  value: void 0,
  setSelected: function() {
    return false;
  },
  setFocused: function() {
    return false;
  },
  isPortaled: true,
  parentMenuContext: void 0,
  menuRows: (0, import_hooks.createMenuRows)(),
  registerActiveSubmenu: function() {
    return false;
  },
  closeActiveSubmenu: function() {
    return false;
  },
  shouldMatchContainerWidth: false,
  isSubmenu: false,
  hasActiveSubmenu: false,
  slideSubmenu: false,
  topLevelTriggerRef: void 0,
  closeMenu: function() {
    return false;
  },
  closeOnSelection: true
};
var MenuContext = React.createContext(defaultValue);
MenuContext.displayName = "MenuContext";
var defaultContentValue = {
  placement: "bottom-start",
  offset: 4,
  isRootMenuOpen: false
};
var MenuContentContext = React.createContext(defaultContentValue);
MenuContentContext.displayName = "MenuContentContext";

// ../src/menu/row_accessory.tsx
var import_classnames = __toESM(require("classnames"));
var React2 = __toESM(require("react"));

// ../src/menu/menu.css.ts
var import_createRuntimeFn = require("@vanilla-extract/recipes/createRuntimeFn");
var cookMenuRowClassName = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1azk22qh_21-1-1", variantClassNames: { hasReducedMotion: { true: "dig-1azk22qi_21-1-1", false: "dig-1azk22qj_21-1-1" }, isInteractive: { true: "dig-1azk22qk_21-1-1", false: "dig-1azk22ql_21-1-1" }, focus: { true: "dig-1azk22qm_21-1-1", false: "dig-1azk22qn_21-1-1" }, active: { true: "dig-1azk22qo_21-1-1", false: "dig-1azk22qp_21-1-1" }, hover: { true: "dig-1azk22qq_21-1-1", false: "dig-1azk22qr_21-1-1" }, disabled: { true: "dig-1azk22qs_21-1-1", false: "dig-1azk22qt_21-1-1" } }, defaultVariants: { hasReducedMotion: false, isInteractive: false, focus: false, active: false, hover: false, disabled: false }, compoundVariants: [[{ isInteractive: true, focus: true }, "dig-1azk22qe_21-1-1"], [{ isInteractive: true, hover: true }, "dig-1azk22qg_21-1-1"], [{ isInteractive: true, active: true }, "dig-1azk22qf_21-1-1"]] });
var cookMenuSegmentClassName = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1azk22q5_21-1-1", variantClassNames: { withoutPadding: { true: "dig-1azk22q6_21-1-1", false: "dig-1azk22q7_21-1-1" } }, defaultVariants: { withoutPadding: false }, compoundVariants: [] });
var menuBackdropClassName = "dig-1azk22q1_21-1-1";
var menuCanvasClassName = "dig-1azk22q4_21-1-1";
var menuClassName = "dig-1azk22q0_21-1-1";
var menuContentClassName = "dig-1azk22q3_21-1-1";
var menuRowAccessoryClassName = "dig-1azk22qx_21-1-1";
var menuRowContentClassName = "dig-1azk22qu_21-1-1";
var menuRowDestructiveToneClassName = "dig-1azk22qd_21-1-1";
var menuRowNeutralToneClassName = "dig-1azk22qc_21-1-1";
var menuRowSubtitleClassName = "dig-1azk22qw_21-1-1";
var menuRowTitleClassName = "dig-1azk22qv_21-1-1";
var menuSegmentLabelClassName = "dig-1azk22q8_21-1-1";
var submenuClassName = "dig-1azk22q2_21-1-1";

// ../src/menu/row_accessory.tsx
var _excluded = ["className", "children"];
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var RowAccessory = function(_ref) {
  var className = _ref.className, children = _ref.children, rest = _objectWithoutProperties(_ref, _excluded);
  var cls = (0, import_classnames.default)("dig-Menu-row-accessory", menuRowAccessoryClassName, className);
  return /* @__PURE__ */ React2.createElement("div", __spreadValues({ className: cls }, rest), children);
};
RowAccessory.displayName = "RowAccessory";

// ../src/menu/row_content.tsx
var import_classnames2 = __toESM(require("classnames"));
var React3 = __toESM(require("react"));
var _excluded2 = ["className", "children"];
function _objectWithoutProperties2(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose2(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var RowContent = function(_ref) {
  var className = _ref.className, children = _ref.children, rest = _objectWithoutProperties2(_ref, _excluded2);
  var cls = (0, import_classnames2.default)("dig-Menu-row-content", menuRowContentClassName, className);
  return /* @__PURE__ */ React3.createElement("div", __spreadValues({ className: cls }, rest), children);
};
RowContent.displayName = "RowContent";

// ../src/menu/row_title.tsx
var import_classnames3 = __toESM(require("classnames"));
var React4 = __toESM(require("react"));
var _excluded3 = ["className", "children"];
function _objectWithoutProperties3(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose3(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var RowTitle = function(_ref) {
  var className = _ref.className, children = _ref.children, rest = _objectWithoutProperties3(_ref, _excluded3);
  var cls = (0, import_classnames3.default)("dig-Menu-row-title", menuRowTitleClassName, className);
  return /* @__PURE__ */ React4.createElement("div", __spreadValues({ className: cls }, rest), children);
};
RowTitle.displayName = "RowTitle";

// ../src/menu/row_subtitle.tsx
var import_classnames4 = __toESM(require("classnames"));
var React5 = __toESM(require("react"));
var _excluded4 = ["className", "children"];
function _objectWithoutProperties4(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose4(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose4(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var RowSubtitle = function(_ref) {
  var className = _ref.className, children = _ref.children, rest = _objectWithoutProperties4(_ref, _excluded4);
  var cls = (0, import_classnames4.default)("dig-Menu-row-subtitle", menuRowSubtitleClassName, className);
  return /* @__PURE__ */ React5.createElement("div", __spreadValues({ className: cls }, rest), children);
};
RowSubtitle.displayName = "RowSubtitle";

// ../src/menu/row.tsx
var import_hooks2 = require("@dropbox/dig-components/hooks");
var import_focus_visible = require("focus-visible");
var import_dig_foundations = require("@dropbox/dig-foundations");
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var _excluded5 = ["tagName", "role", "className", "children", "onMouseEnter", "withTitle", "withSubtitle", "withLeftAccessory", "withRightAccessory", "disabled", "interactive", "tabIndex", "tone", "preferComposition", "_isSubmenuTrigger", "onClick", "_pseudoClass"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties5(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose5(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose5(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Row = React6.forwardRef(function(_ref, ref) {
  var _ref$tagName = _ref.tagName, TagName = _ref$tagName === void 0 ? "div" : _ref$tagName, _ref$role = _ref.role, role = _ref$role === void 0 ? "menuitem" : _ref$role, className = _ref.className, children = _ref.children, onMouseEnter = _ref.onMouseEnter, withTitle = _ref.withTitle, withSubtitle = _ref.withSubtitle, withLeftAccessory = _ref.withLeftAccessory, withRightAccessory = _ref.withRightAccessory, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$interactive = _ref.interactive, interactive = _ref$interactive === void 0 ? false : _ref$interactive, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? -1 : _ref$tabIndex, _ref$tone = _ref.tone, tone = _ref$tone === void 0 ? "neutral" : _ref$tone, _ref$preferCompositio = _ref.preferComposition, preferComposition = _ref$preferCompositio === void 0 ? false : _ref$preferCompositio, _ref$_isSubmenuTrigge = _ref._isSubmenuTrigger, _isSubmenuTrigger = _ref$_isSubmenuTrigge === void 0 ? false : _ref$_isSubmenuTrigge, onClick = _ref.onClick, _pseudoClass = _ref._pseudoClass, rest = _objectWithoutProperties5(_ref, _excluded5);
  var localRef = React6.useRef(null);
  var _React$useContext = React6.useContext(MenuContext), menuRows = _React$useContext.menuRows, parentMenuContext = _React$useContext.parentMenuContext, closeActiveSubmenu = _React$useContext.closeActiveSubmenu;
  var rows = _isSubmenuTrigger ? parentMenuContext && parentMenuContext.menuRows || (0, import_hooks2.createMenuRows)() : menuRows;
  var _useMenuItem = (0, import_hooks2.useMenuItem)({
    interactive: interactive,
    disabled: disabled,
    ref: localRef,
    role: role
  }, rows), getItemProps = _useMenuItem.getItemProps;
  var _usePrefersReducedMot = (0, import_dig_foundations.usePrefersReducedMotion)(), hasReducedMotion = _usePrefersReducedMot.hasReducedMotion;
  var cls = (0, import_classnames5.default)("dig-Menu-row", "dig-Menu-row--".concat(tone), cookMenuRowClassName({
    hasReducedMotion: hasReducedMotion,
    isInteractive: interactive,
    focus: _pseudoClass === "focus",
    active: _pseudoClass === "active",
    hover: _pseudoClass === "hover"
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, menuRowNeutralToneClassName, tone === "neutral"), menuRowDestructiveToneClassName, tone === "destructive"), "dig-Menu-row--disabled", disabled), "dig-Menu-row--interactive", interactive), "dig-Menu-row--active", _pseudoClass === "active"), "dig-Menu-row--focused", _pseudoClass === "focus"), "dig-Menu-row--hover", _pseudoClass === "hover"), "dig-Menu-row--reducedMotion", hasReducedMotion), className);
  var handleMouseEnter = function(evt) {
    closeActiveSubmenu();
    if (onMouseEnter) {
      onMouseEnter(evt);
    }
  };
  React6.useImperativeHandle(ref, function() {
    return {
      // `focus()` is required for submenu keyboard navigation
      focus: function(options) {
        if (!localRef.current)
          return;
        return localRef.current.focus(options);
      },
      // The set of properties below are used by `floating-ui`
      getBoundingClientRect: function() {
        if (!localRef.current)
          return;
        return localRef.current.getBoundingClientRect();
      }
    };
  });
  return /* @__PURE__ */ React6.createElement(TagName, __spreadValues({ className: cls, ref: localRef }, getItemProps(_objectSpread({
    onMouseEnter: handleMouseEnter,
    // If this has been disabled we need to prevent click events from being called
    // since we do not use a `disabled` attribute or a native `button` element.
    onClick: function(evt) {
      if (disabled) {
        evt.preventDefault();
        return;
      }
      if (onClick) {
        onClick(evt);
      }
    }
  }, rest))), preferComposition && children, !preferComposition && /* @__PURE__ */ React6.createElement(React6.Fragment, null, withLeftAccessory && /* @__PURE__ */ React6.createElement(RowAccessory, null, withLeftAccessory), /* @__PURE__ */ React6.createElement(RowContent, null, /* @__PURE__ */ React6.createElement(RowTitle, null, withTitle || children), withSubtitle && /* @__PURE__ */ React6.createElement(RowSubtitle, null, withSubtitle)), withRightAccessory && /* @__PURE__ */ React6.createElement(RowAccessory, null, withRightAccessory)));
});
Row.displayName = "Row";

// ../src/menu/action_item.tsx
var _excluded6 = ["children", "disabled", "value", "onClick", "onFocus"];
function _objectWithoutProperties6(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose6(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose6(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ActionItem = React7.forwardRef(function(_ref, ref) {
  var children = _ref.children, disabled = _ref.disabled, value = _ref.value, onClick = _ref.onClick, onFocus = _ref.onFocus, rest = _objectWithoutProperties6(_ref, _excluded6);
  var _React$useContext = React7.useContext(MenuContext), setFocused = _React$useContext.setFocused, setSelected = _React$useContext.setSelected;
  var handleClick = function(evt) {
    setSelected(value, evt);
    if (onClick) {
      onClick(evt);
    }
  };
  var handleFocus = function(evt) {
    setFocused(value);
    if (onFocus) {
      onFocus(evt);
    }
  };
  return /* @__PURE__ */ React7.createElement(Row, __spreadProps(__spreadValues({ interactive: true, disabled: disabled, onClick: handleClick, onFocus: handleFocus }, rest), { ref: ref }), children);
});
ActionItem.displayName = "ActionItem";

// ../src/menu/canvas.tsx
var import_classnames6 = __toESM(require("classnames"));
var React8 = __toESM(require("react"));
var import_dig_foundations2 = require("@dropbox/dig-foundations");
function _typeof2(o) {
  "@babel/helpers - typeof";
  return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof2(o);
}
var _excluded7 = ["className", "style", "children"];
function ownKeys2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys2(Object(t), true).forEach(function(r2) {
      _defineProperty2(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys2(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty2(obj, key, value) {
  key = _toPropertyKey2(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey2(t) {
  var i = _toPrimitive2(t, "string");
  return "symbol" == _typeof2(i) ? i : String(i);
}
function _toPrimitive2(t, r) {
  if ("object" != _typeof2(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof2(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties7(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose7(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose7(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Canvas = function(_ref) {
  var className = _ref.className, style = _ref.style, children = _ref.children, rest = _objectWithoutProperties7(_ref, _excluded7);
  var _React$useContext = React8.useContext(MenuContext), inverse = _React$useContext.inverse, maxHeight = _React$useContext.maxHeight;
  var inverseClassName = (0, import_dig_foundations2.useTheme)().getInverseProps().className;
  var cls = (0, import_classnames6.default)(className, "dig-Menu-canvas", menuCanvasClassName, _defineProperty2({}, inverseClassName, inverse));
  return /* @__PURE__ */ React8.createElement("div", __spreadProps(__spreadValues({ className: cls, role: "presentation" }, rest), { style: _objectSpread2(_objectSpread2({}, style), {}, {
    maxHeight: maxHeight
  }) }), children);
};
Canvas.displayName = "Canvas";

// ../src/menu/content.tsx
var import_classnames8 = __toESM(require("classnames"));
var React11 = __toESM(require("react"));

// ../src/menu/menu_motion.tsx
var React9 = __toESM(require("react"));
var import_motion = require("@dropbox/dig-components/motion");
var import_dig_foundations3 = require("@dropbox/dig-foundations");
var _excluded8 = ["children", "submenuMotion", "isSubmenu", "slideSubmenu"];
function _typeof3(o) {
  "@babel/helpers - typeof";
  return _typeof3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof3(o);
}
function _objectWithoutProperties8(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose8(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose8(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function ownKeys3(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread3(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys3(Object(t), true).forEach(function(r2) {
      _defineProperty3(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys3(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty3(obj, key, value) {
  key = _toPropertyKey3(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey3(t) {
  var i = _toPrimitive3(t, "string");
  return "symbol" == _typeof3(i) ? i : String(i);
}
function _toPrimitive3(t, r) {
  if ("object" != _typeof3(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof3(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SUBMENU_OFFSET = 48;
var PARENT_OFFSET = 24;
var MENU_MOTION_DURATION = 125;
var MENU_SLIDE_DURATION_MS = MENU_MOTION_DURATION;
var AppearMenuMotion = function(_ref) {
  var animationDirection = _ref.animationDirection, offset2 = _ref.offset, isOpen = _ref.isOpen, isRootMenuOpen = _ref.isRootMenuOpen, onTransitionComplete = _ref.onTransitionComplete, children = _ref.children;
  var _usePrefersReducedMot = (0, import_dig_foundations3.usePrefersReducedMotion)(), hasReducedMotion = _usePrefersReducedMot.hasReducedMotion;
  var verticalOffset = animationDirection === "up" ? offset2 : -1 * offset2;
  var onEntered = React9.useCallback(function() {
    if (typeof onTransitionComplete === "function") {
      onTransitionComplete({
        isOpen: true
      });
    }
  }, [onTransitionComplete]);
  var onExited = React9.useCallback(function() {
    if (typeof onTransitionComplete === "function") {
      onTransitionComplete({
        isOpen: false
      });
    }
  }, [onTransitionComplete]);
  return (
    // Note that menu must be mounted for animation to work when isOpen is
    // triggered, which is why only pass it through to the in prop and
    // children instead.
    /* @__PURE__ */ React9.createElement(
      import_motion.Motion,
      {
        _disableMotionDuration: hasReducedMotion,
        onEntered: onEntered,
        onExited: onExited,
        transitionIn: {
          transitions: [{
            property: animationDirection,
            value: 0
          }, {
            property: "opacity",
            value: 1
          }],
          easing: "enter",
          duration: MENU_MOTION_DURATION
        },
        transitionOut: {
          transitions: [{
            property: "opacity",
            value: 0
          }, {
            property: animationDirection,
            value: verticalOffset
          }],
          easing: "leave",
          duration: MENU_MOTION_DURATION
        },
        style: {
          opacity: 0
        },
        in: isOpen && isRootMenuOpen,
        mountOnEnter: true,
        unmountOnExit: true
      },
      function(_ref2) {
        var motionState = _ref2.state, style = _ref2.style;
        var isVisible = isOpen || motionState !== "exited";
        return isVisible && children({
          canvasStyle: style,
          overlayStyle: {}
        });
      }
    )
  );
};
AppearMenuMotion.displayName = "AppearMenuMotion";
var getDefaultSlideStyle = function(motion, isSubmenu) {
  if (motion === 2 /* CloseLeft */) {
    return {
      transform: "translate(-".concat(PARENT_OFFSET, "px, ", 0, "px)"),
      opacity: 0
    };
  }
  if (isSubmenu) {
    return {
      transform: "translate(".concat(SUBMENU_OFFSET, "px, ", 0, "px)"),
      opacity: 0
    };
  }
  return {};
};
var SlideMenuMotion = function(_ref3) {
  var submenuMotion = _ref3.submenuMotion, isSubmenu = _ref3.isSubmenu, animationDirection = _ref3.animationDirection, offset2 = _ref3.offset, isRootMenuOpen = _ref3.isRootMenuOpen, propsStyle = _ref3.style, children = _ref3.children;
  var defaultStyle = getDefaultSlideStyle(submenuMotion, isSubmenu);
  var _usePrefersReducedMot2 = (0, import_dig_foundations3.usePrefersReducedMotion)(), hasReducedMotion = _usePrefersReducedMot2.hasReducedMotion;
  var isSubmenuOpen = submenuMotion === 0 /* OpenLeft */ || submenuMotion === 1 /* OpenRight */;
  var verticalOffset = animationDirection === "up" ? offset2 : -1 * offset2;
  return /* @__PURE__ */ React9.createElement(import_motion.Motion, { _disableMotionDuration: hasReducedMotion, transitionIn: {
    transitions: [{
      property: "left",
      value: 0
    }, {
      property: animationDirection,
      value: 0
    }, {
      property: "opacity",
      value: 1
    }],
    easing: "transition",
    duration: MENU_MOTION_DURATION
  }, transitionOut: {
    transitions: [
      // Check if this is a submenu first so we can do the correct transition.
      // Submenus need to slide left/right
      // the root menu needs to slide up/down
      {
        property: "left",
        value: isSubmenu ? PARENT_OFFSET : 0
      },
      {
        property: animationDirection,
        value: isSubmenu ? 0 : verticalOffset
      },
      {
        property: "opacity",
        value: 0
      }
    ],
    easing: "transition",
    duration: MENU_MOTION_DURATION
  }, style: {
    opacity: 0
  }, in: isSubmenuOpen }, function(_ref4) {
    var slideLeftState = _ref4.state, slideLeftStyle = _ref4.style;
    return /* @__PURE__ */ React9.createElement(import_motion.Motion, { _disableMotionDuration: hasReducedMotion, transitionIn: {
      transitions: [{
        property: "left",
        value: 0
      }, {
        property: animationDirection,
        value: 0
      }, {
        property: "opacity",
        value: 1
      }],
      easing: "transition",
      duration: MENU_MOTION_DURATION
    }, transitionOut: {
      transitions: [{
        property: "left",
        value: isSubmenu ? -1 * SUBMENU_OFFSET : 0
      }, {
        property: animationDirection,
        value: isSubmenu ? 0 : verticalOffset
      }, {
        property: "opacity",
        value: 0
      }],
      easing: "transition",
      duration: MENU_MOTION_DURATION
    }, style: {
      opacity: 0
    }, in: isSubmenuOpen }, function(_ref5) {
      var slideRightState = _ref5.state, slideRightStyle = _ref5.style;
      if (!isRootMenuOpen) {
        return children({
          canvasStyle: _objectSpread3({}, propsStyle),
          overlayStyle: {}
        });
      }
      if (submenuMotion === 4 /* None */) {
        return children({
          canvasStyle: {},
          overlayStyle: {
            visibility: "hidden",
            pointerEvents: "none"
          }
        });
      }
      var isLeftDirection = submenuMotion === 2 /* CloseLeft */ || submenuMotion === 0 /* OpenLeft */;
      var isVisible = isSubmenuOpen || slideLeftState !== "exited" || slideRightState !== "exited";
      var overlayStyle = isVisible ? {} : {
        visibility: "hidden",
        pointerEvents: "none"
      };
      var canvasStyle = isVisible ? _objectSpread3(_objectSpread3({}, propsStyle), isLeftDirection ? _objectSpread3({}, slideLeftStyle) : _objectSpread3({}, slideRightStyle)) : _objectSpread3(_objectSpread3({}, propsStyle), defaultStyle);
      return children({
        canvasStyle: canvasStyle,
        overlayStyle: overlayStyle
      });
    });
  });
};
SlideMenuMotion.displayName = "SlideMenuMotion";
var MenuMotion = function(_ref6) {
  var children = _ref6.children, submenuMotion = _ref6.submenuMotion, isSubmenu = _ref6.isSubmenu, slideSubmenu = _ref6.slideSubmenu, rest = _objectWithoutProperties8(_ref6, _excluded8);
  if (!slideSubmenu) {
    return /* @__PURE__ */ React9.createElement(AppearMenuMotion, __spreadValues({}, rest), children);
  }
  return /* @__PURE__ */ React9.createElement(AppearMenuMotion, __spreadValues({}, rest), function(_ref7) {
    var style = _ref7.canvasStyle;
    return /* @__PURE__ */ React9.createElement(SlideMenuMotion, __spreadValues({ isSubmenu: isSubmenu, submenuMotion: submenuMotion, slideSubmenu: slideSubmenu, style: style }, rest), children);
  });
};
MenuMotion.displayName = "MenuMotion";

// ../src/menu/menu_overlay.tsx
var import_classnames7 = __toESM(require("classnames"));
var React10 = __toESM(require("react"));
var import_web = require("@react-hookz/web");
var import_react = require("@floating-ui/react");
var import_layer = require("@dropbox/dig-components/layer");
function _typeof4(o) {
  "@babel/helpers - typeof";
  return _typeof4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof4(o);
}
var _excluded9 = ["className", "children", "placement", "anchorRef", "offsetDistance", "auto", "isPortaled", "positioningStrategy", "style"];
function ownKeys4(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread4(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys4(Object(t), true).forEach(function(r2) {
      _defineProperty4(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys4(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty4(obj, key, value) {
  key = _toPropertyKey4(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey4(t) {
  var i = _toPrimitive4(t, "string");
  return "symbol" == _typeof4(i) ? i : String(i);
}
function _toPrimitive4(t, r) {
  if ("object" != _typeof4(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof4(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _objectWithoutProperties9(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose9(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose9(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var MenuOverlay = React10.forwardRef(function(_ref, ref) {
  var className = _ref.className, children = _ref.children, placement = _ref.placement, anchorRef = _ref.anchorRef, _ref$offsetDistance = _ref.offsetDistance, offsetDistance = _ref$offsetDistance === void 0 ? 0 : _ref$offsetDistance, _ref$auto = _ref.auto, auto = _ref$auto === void 0 ? false : _ref$auto, _ref$isPortaled = _ref.isPortaled, isPortaled = _ref$isPortaled === void 0 ? true : _ref$isPortaled, _ref$positioningStrat = _ref.positioningStrategy, positioningStrategy = _ref$positioningStrat === void 0 ? "absolute" : _ref$positioningStrat, style = _ref.style, rest = _objectWithoutProperties9(_ref, _excluded9);
  var _React$useContext = React10.useContext(MenuContext), setMaxMenuHeight = _React$useContext.setMaxMenuHeight;
  var _React$useState = React10.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), shouldReAttachAnchorRef = _React$useState2[0], setShouldReAttachAnchorRef = _React$useState2[1];
  var applyFn = React10.useCallback(function(_ref2) {
    var availableHeight = _ref2.availableHeight;
    setMaxMenuHeight && setMaxMenuHeight(availableHeight);
  }, [setMaxMenuHeight]);
  var _useFloating = (0, import_react.useFloating)({
    placement: placement,
    strategy: positioningStrategy,
    // We assume RO is pollyfilled.
    whileElementsMounted: function(reference, floating, update2) {
      return (0, import_react.autoUpdate)(reference, floating, update2, {
        elementResize: true
      });
    },
    middleware: [(0, import_react.offset)(offsetDistance)].concat(_toConsumableArray(auto ? [(0, import_react.flip)({
      fallbackStrategy: "bestFit"
    })] : []), [(0, import_react.size)({
      apply: applyFn
    })], _toConsumableArray(auto ? [(0, import_react.shift)({
      limiter: (0, import_react.limitShift)()
    })] : []))
  }), x = _useFloating.x, y = _useFloating.y, refs = _useFloating.refs, strategy = _useFloating.strategy, update = _useFloating.update, floatingPlacement = _useFloating.placement;
  (0, import_web.useIsomorphicLayoutEffect)(function() {
    refs.setReference(anchorRef.current);
  }, [refs, anchorRef]);
  (0, import_web.useIsomorphicLayoutEffect)(function() {
    if (shouldReAttachAnchorRef) {
      refs.setReference(anchorRef.current);
      setShouldReAttachAnchorRef(false);
    }
  }, [refs, anchorRef, shouldReAttachAnchorRef]);
  React10.useImperativeHandle(ref, function() {
    return {
      update: function() {
        update();
        setShouldReAttachAnchorRef(true);
      }
    };
  }, [update]);
  var floatingX = x ? Math.round(x) : 0;
  var floatingY = y ? Math.round(y) : 0;
  var cls = (0, import_classnames7.default)("dig-Menu-Overlay", "dig-Menu-Overlay--".concat(floatingPlacement), className);
  return /* @__PURE__ */ React10.createElement(import_layer.Layer, { _elevateByZ: import_layer.ELEVATED_BASE_INDEX, isPortaled: isPortaled }, /* @__PURE__ */ React10.createElement("div", __spreadValues({ className: cls, ref: refs.setFloating, style: _objectSpread4(_objectSpread4({}, style), {}, {
    position: strategy,
    top: "0",
    left: "0",
    transform: "translate3d(".concat(floatingX, "px,").concat(floatingY, "px,0)")
  }) }, rest), children));
});
MenuOverlay.displayName = "MenuOverlay";

// ../src/menu/content.tsx
var _excluded10 = ["children", "className", "auto", "placement", "open", "triggerRef", "triggerOffset", "positioningStrategy", "onContentOpened", "tabIndex", "motionProvider", "onTransitionComplete", "minWidth"];
function ownKeys5(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread5(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys5(Object(t), true).forEach(function(r2) {
      _defineProperty5(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys5(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty5(obj, key, value) {
  key = _toPropertyKey5(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey5(t) {
  var i = _toPrimitive5(t, "string");
  return "symbol" == _typeof5(i) ? i : String(i);
}
function _toPrimitive5(t, r) {
  if ("object" != _typeof5(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof5(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _typeof5(o) {
  "@babel/helpers - typeof";
  return _typeof5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof5(o);
}
function _slicedToArray2(arr, i) {
  return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i) || _unsupportedIterableToArray2(arr, i) || _nonIterableRest2();
}
function _nonIterableRest2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray2(o, minLen);
}
function _arrayLikeToArray2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit2(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles2(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _objectWithoutProperties10(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose10(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose10(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var getAnimationDirection = function(placement) {
  switch (placement) {
    case "top":
    case "top-start":
    case "top-end":
    default:
      return "up";
    case "bottom":
    case "bottom-start":
    case "bottom-end":
      return "down";
  }
};
var Content = React11.forwardRef(function(_ref, ref) {
  var children = _ref.children, className = _ref.className, _ref$auto = _ref.auto, auto = _ref$auto === void 0 ? true : _ref$auto, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$open = _ref.open, open = _ref$open === void 0 ? false : _ref$open, triggerRef = _ref.triggerRef, _ref$triggerOffset = _ref.triggerOffset, triggerOffset = _ref$triggerOffset === void 0 ? 4 : _ref$triggerOffset, _ref$positioningStrat = _ref.positioningStrategy, positioningStrategy = _ref$positioningStrat === void 0 ? "absolute" : _ref$positioningStrat, onContentOpened = _ref.onContentOpened, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? -1 : _ref$tabIndex, _ref$motionProvider = _ref.motionProvider, MotionProvider = _ref$motionProvider === void 0 ? MenuMotion : _ref$motionProvider, onTransitionComplete = _ref.onTransitionComplete, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 90 : _ref$minWidth, rest = _objectWithoutProperties10(_ref, _excluded10);
  var overlayRef = React11.useRef(null);
  var animationDirection = getAnimationDirection(placement);
  var _React$useState = React11.useState({}), _React$useState2 = _slicedToArray2(_React$useState, 2), containerStyles = _React$useState2[0], setContainerStyles = _React$useState2[1];
  var _React$useState3 = React11.useState(4 /* None */), _React$useState4 = _slicedToArray2(_React$useState3, 2), menuMotion = _React$useState4[0], setMenuMotion = _React$useState4[1];
  var _React$useContext = React11.useContext(MenuContext), contentRef = _React$useContext.contentRef, shouldMatchContainerWidth = _React$useContext.shouldMatchContainerWidth, isPortaled = _React$useContext.isPortaled, isSubmenu = _React$useContext.isSubmenu, hasActiveSubmenu = _React$useContext.hasActiveSubmenu, slideSubmenu = _React$useContext.slideSubmenu;
  var cls = (0, import_classnames8.default)("dig-Menu-content", "dig-Menu-content--".concat(placement), menuContentClassName, className);
  var _React$useContext2 = React11.useContext(MenuContentContext), parentIsRootMenuOpen = _React$useContext2.isRootMenuOpen;
  var isRootMenuOpen = isSubmenu ? parentIsRootMenuOpen : open;
  var contentDefaultValue = {
    placement: placement,
    offset: triggerOffset,
    isRootMenuOpen: isRootMenuOpen
  };
  React11.useEffect(function() {
    if (slideSubmenu) {
      if (hasActiveSubmenu) {
        setMenuMotion(2 /* CloseLeft */);
      } else {
        setMenuMotion(0 /* OpenLeft */);
      }
    }
  }, [hasActiveSubmenu, slideSubmenu]);
  React11.useEffect(function() {
    if (slideSubmenu) {
      if (!isRootMenuOpen) {
        setMenuMotion(4 /* None */);
      } else if (open) {
        setMenuMotion(1 /* OpenRight */);
      } else {
        setMenuMotion(3 /* CloseRight */);
      }
    }
  }, [open, slideSubmenu, isRootMenuOpen]);
  React11.useEffect(
    function() {
      if (open && triggerRef.current) {
        setContainerStyles({
          minWidth: shouldMatchContainerWidth || minWidth === "matchContainingWidth" ? triggerRef.current.getBoundingClientRect().width : minWidth
        });
      }
    },
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [open]
  );
  React11.useImperativeHandle(ref, function() {
    return {
      update: function() {
        if (overlayRef.current) {
          overlayRef.current.update();
        }
      }
    };
  });
  React11.useEffect(function() {
    if (open && onContentOpened) {
      onContentOpened();
    }
  }, [open]);
  var normalizedMotionOffset = React11.useMemo(function() {
    var offset2 = 0;
    if (typeof triggerOffset === "number") {
      offset2 = triggerOffset;
    } else if (_typeof5(triggerOffset) === "object") {
      offset2 = triggerOffset.mainAxis || triggerOffset.crossAxis;
    }
    return offset2 ? offset2 : 0;
  }, [triggerOffset]);
  return /* @__PURE__ */ React11.createElement(MenuContentContext.Provider, { value: contentDefaultValue }, /* @__PURE__ */ React11.createElement(MotionProvider, { animationDirection: animationDirection, offset: normalizedMotionOffset, isOpen: open, isSubmenu: isSubmenu, submenuMotion: menuMotion, slideSubmenu: slideSubmenu, isRootMenuOpen: isRootMenuOpen, onTransitionComplete: onTransitionComplete }, function(_ref2) {
    var canvasStyle = _ref2.canvasStyle, overlayStyle = _ref2.overlayStyle;
    return /* @__PURE__ */ React11.createElement(MenuOverlay, { anchorRef: triggerRef, auto: auto, placement: placement, offsetDistance: triggerOffset, positioningStrategy: positioningStrategy, isPortaled: isPortaled, style: _objectSpread5(_objectSpread5({}, overlayStyle), containerStyles), ref: overlayRef }, /* @__PURE__ */ React11.createElement("nav", __spreadValues({ className: cls, ref: contentRef, tabIndex: -1 }, rest), /* @__PURE__ */ React11.createElement(Canvas, { style: canvasStyle }, children)));
  }));
});
Content.displayName = "Content";

// ../src/menu/link_item.tsx
var React12 = __toESM(require("react"));
var _excluded11 = ["children", "disabled", "href", "onClick"];
function _objectWithoutProperties11(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose11(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose11(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var LinkItem = React12.forwardRef(function(_ref, ref) {
  var children = _ref.children, disabled = _ref.disabled, href = _ref.href, onClick = _ref.onClick, rest = _objectWithoutProperties11(_ref, _excluded11);
  var _React$useContext = React12.useContext(MenuContext), closeMenu = _React$useContext.closeMenu, closeOnSelection = _React$useContext.closeOnSelection;
  var handleClick = function(evt) {
    if (closeOnSelection) {
      closeMenu({
        autoFocus: false
      });
    }
    if (onClick) {
      onClick(evt);
    }
  };
  return /* @__PURE__ */ React12.createElement(Row, __spreadProps(__spreadValues({ tagName: "a", href: href, onClick: handleClick, interactive: true, disabled: disabled }, rest), { ref: ref }), children);
});
LinkItem.displayName = "LinkItem";

// ../src/menu/segment.tsx
var import_classnames9 = __toESM(require("classnames"));
var import_typography = require("@dropbox/dig-components/typography");
var React13 = __toESM(require("react"));
var _excluded12 = ["className", "children", "withLabel", "_withoutPadding"];
function _objectWithoutProperties12(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose12(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose12(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Segment = function(_ref) {
  var className = _ref.className, children = _ref.children, withLabel = _ref.withLabel, _withoutPadding = _ref._withoutPadding, rest = _objectWithoutProperties12(_ref, _excluded12);
  var cls = (0, import_classnames9.default)("dig-Menu-segment", {
    "dig-Menu-segment--withoutPadding": _withoutPadding
  }, cookMenuSegmentClassName({
    withoutPadding: _withoutPadding
  }), className);
  return /* @__PURE__ */ React13.createElement("div", __spreadValues({ className: cls }, rest), withLabel && /* @__PURE__ */ React13.createElement("div", { className: (0, import_classnames9.default)("dig-Menu-segment-label", menuSegmentLabelClassName) }, /* @__PURE__ */ React13.createElement(import_typography.Text, { size: "small", color: "subtle", isBold: true }, withLabel)), children);
};
Segment.displayName = "Segment";

// ../src/menu/select_item.tsx
var React14 = __toESM(require("react"));
var import_dig_icons = require("@dropbox/dig-icons");
var import_assets = require("@dropbox/dig-icons/assets");
var _excluded13 = ["children", "selected", "role"];
function _objectWithoutProperties13(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose13(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose13(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var SelectItem = function(_ref) {
  var children = _ref.children, _ref$selected = _ref.selected, selected = _ref$selected === void 0 ? false : _ref$selected, _ref$role = _ref.role, role = _ref$role === void 0 ? "menuitemradio" : _ref$role, rest = _objectWithoutProperties13(_ref, _excluded13);
  var withLeftAccessory = selected ? (
    // UIIcon here has no aria-label which is fine because this is just an additional visual
    // indicator and is not a standalone button on it's own (ie: the icon is not focusable
    // by itself).
    /* @__PURE__ */ React14.createElement(import_dig_icons.UIIcon, { src: import_assets.CheckmarkLine })
  ) : (
    // Setting prop to true will make sure the accessory is always rendered even
    // if empty, so items are always aligned regardless of check icon or not
    true
  );
  return /* @__PURE__ */ React14.createElement(ActionItem, __spreadValues({ role: role, "aria-checked": selected, withLeftAccessory: withLeftAccessory }, rest), children);
};
SelectItem.displayName = "SelectItem";

// ../src/menu/submenu.tsx
var React17 = __toESM(require("react"));
var import_classnames11 = __toESM(require("classnames"));

// ../src/_global/constants.ts
var ensureFocusable = function(selector) {
  return "".concat(selector, ':not([tabindex="-1"])');
};
var TAB_KEY = "Tab";
var ENTER_KEY = "Enter";
var ESC_KEY = "Escape";
var SPACEBAR_KEY = " ";
var UP_ARROW_KEY = "ArrowUp";
var DOWN_ARROW_KEY = "ArrowDown";
var LEFT_ARROW_KEY = "ArrowLeft";
var RIGHT_ARROW_KEY = "ArrowRight";
var DELETE_KEY = "Delete";
var BACKSPACE_KEY = "Backspace";
var NONE_SELECTED_INDEX = -2;
var LAST_SELECTED_INDEX = -1;
var FOCUSABLE_SELECTOR = function(additionalSelectors) {
  return Array.prototype.concat.apply([], [
    // buttons and links
    ["button", '[role="button"]', '[role="link"]', "[href]"].map(ensureFocusable),
    // controls
    ["select", "textarea", '[role="textbox"]'].map(ensureFocusable),
    additionalSelectors,
    // other
    ['[tabindex]:not([tabindex="-1"])']
  ]).join(",");
};
var VISUALLY_HIDDEN_CSS = {
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "0 -1px -1px 0",
  overflow: "hidden",
  padding: "0",
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
var buttonDataAttributeName = "data-dig-button";
var buttonDataSelector = "[".concat(buttonDataAttributeName, "]");
var buttonContentDataAttributeName = "data-dig-button-content";
var buttonContentDataSelector = "[".concat(buttonContentDataAttributeName, "]");
var splitButtonDataAttributeName = "data-dig-split-button";
var splitButtonDataSelector = "[".concat(splitButtonDataAttributeName, "]");
var iconButtonDataAttributeName = "data-dig-icon-button";
var iconButtonDataSelector = "[".concat(iconButtonDataAttributeName, "]");

// ../src/menu/submenu.tsx
var import_hooks4 = require("@dropbox/dig-components/hooks");
var import_dig_icons2 = require("@dropbox/dig-icons");
var import_assets2 = require("@dropbox/dig-icons/assets");

// ../src/menu/wrapper.tsx
var import_classnames10 = __toESM(require("classnames"));
var React16 = __toESM(require("react"));
var import_click_outside = require("@dropbox/dig-components/click_outside");
var import_hooks3 = require("@dropbox/dig-components/hooks");

// ../src/menu/constants.ts
var INTERACTIVE_MENU_ROW_CLASSNAME = "dig-Menu-row--interactive";
var INTERACTIVE_MENU_ROW_SELECTORS = (
  // interactive Menu.Rows
  [".".concat(INTERACTIVE_MENU_ROW_CLASSNAME, '[role="menuitem"]'), ".".concat(INTERACTIVE_MENU_ROW_CLASSNAME, '[role="menuitemcheckbox"]'), ".".concat(INTERACTIVE_MENU_ROW_CLASSNAME, '[role="menuitemradio"]')]
);

// ../src/menu/useMaxMenuHeight.ts
var React15 = __toESM(require("react"));
function _typeof6(o) {
  "@babel/helpers - typeof";
  return _typeof6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof6(o);
}
function _slicedToArray3(arr, i) {
  return _arrayWithHoles3(arr) || _iterableToArrayLimit3(arr, i) || _unsupportedIterableToArray3(arr, i) || _nonIterableRest3();
}
function _nonIterableRest3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray3(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray3(o, minLen);
}
function _arrayLikeToArray3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit3(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles3(arr) {
  if (Array.isArray(arr))
    return arr;
}
var SCREEN_EDGE_OFFSET = 8;
var DEFAULT_MAX_HEIGHT = 200;
var useMaxMenuHeight = function(hasMaxHeight) {
  var _React$useState = React15.useState(void 0), _React$useState2 = _slicedToArray3(_React$useState, 2), maxHeight = _React$useState2[0], _setMaxHeight = _React$useState2[1];
  var setMaxHeight = React15.useCallback(function(availableHeight) {
    var calculatedMaxHeight = availableHeight;
    switch (_typeof6(hasMaxHeight)) {
      case "number":
        calculatedMaxHeight = Math.min(hasMaxHeight, availableHeight);
        break;
      case "boolean":
        calculatedMaxHeight = hasMaxHeight ? Math.min(DEFAULT_MAX_HEIGHT, availableHeight) : (
          // This is the default case for this hook where it could cause the canvas
          // to expand to the screen edge, in which case lets take a little height off of it
          // so it doesn't but up directly against the screen edge.
          calculatedMaxHeight - SCREEN_EDGE_OFFSET
        );
    }
    var adjustedMaxHeight = Math.max(DEFAULT_MAX_HEIGHT, calculatedMaxHeight);
    _setMaxHeight(adjustedMaxHeight);
  }, [hasMaxHeight, _setMaxHeight]);
  return [maxHeight, setMaxHeight];
};

// ../src/menu/wrapper.tsx
var import_dig_foundations4 = require("@dropbox/dig-foundations");
function _typeof7(o) {
  "@babel/helpers - typeof";
  return _typeof7 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof7(o);
}
var _excluded14 = ["className", "children", "onSelection", "onToggle", "closeOnSelection", "closeOnBlur", "isPortaled", "matchContainingWidth", "hasMaxHeight", "shouldPropagateClickOutsideMouseEvents", "shouldFocusDisabledRows", "isBlock", "slideSubmenu", "_isSubmenu", "closeOnBlurWhenDefaultPrevented", "inverse", "isContentLabelledByTrigger"];
function ownKeys6(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread6(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys6(Object(t), true).forEach(function(r2) {
      _defineProperty6(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys6(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _slicedToArray4(arr, i) {
  return _arrayWithHoles4(arr) || _iterableToArrayLimit4(arr, i) || _unsupportedIterableToArray4(arr, i) || _nonIterableRest4();
}
function _nonIterableRest4() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray4(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray4(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray4(o, minLen);
}
function _arrayLikeToArray4(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit4(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles4(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _defineProperty6(obj, key, value) {
  key = _toPropertyKey6(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey6(t) {
  var i = _toPrimitive6(t, "string");
  return "symbol" == _typeof7(i) ? i : String(i);
}
function _toPrimitive6(t, r) {
  if ("object" != _typeof7(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof7(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties14(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose14(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose14(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Wrapper = React16.forwardRef(function(_ref, ref) {
  var className = _ref.className, children = _ref.children, onSelection = _ref.onSelection, onToggle = _ref.onToggle, _ref$closeOnSelection = _ref.closeOnSelection, closeOnSelection = _ref$closeOnSelection === void 0 ? true : _ref$closeOnSelection, _ref$closeOnBlur = _ref.closeOnBlur, closeOnBlur = _ref$closeOnBlur === void 0 ? true : _ref$closeOnBlur, _ref$isPortaled = _ref.isPortaled, isPortaled = _ref$isPortaled === void 0 ? true : _ref$isPortaled, _ref$matchContainingW = _ref.matchContainingWidth, matchContainingWidth = _ref$matchContainingW === void 0 ? false : _ref$matchContainingW, _ref$hasMaxHeight = _ref.hasMaxHeight, hasMaxHeight = _ref$hasMaxHeight === void 0 ? false : _ref$hasMaxHeight, _ref$shouldPropagateC = _ref.shouldPropagateClickOutsideMouseEvents, shouldPropagateClickOutsideMouseEvents = _ref$shouldPropagateC === void 0 ? false : _ref$shouldPropagateC, _ref$shouldFocusDisab = _ref.shouldFocusDisabledRows, shouldFocusDisabledRows = _ref$shouldFocusDisab === void 0 ? true : _ref$shouldFocusDisab, _ref$isBlock = _ref.isBlock, isBlock = _ref$isBlock === void 0 ? false : _ref$isBlock, _ref$slideSubmenu = _ref.slideSubmenu, slideSubmenu = _ref$slideSubmenu === void 0 ? false : _ref$slideSubmenu, _ref$_isSubmenu = _ref._isSubmenu, _isSubmenu = _ref$_isSubmenu === void 0 ? false : _ref$_isSubmenu, _ref$closeOnBlurWhenD = _ref.closeOnBlurWhenDefaultPrevented, closeOnBlurWhenDefaultPrevented = _ref$closeOnBlurWhenD === void 0 ? true : _ref$closeOnBlurWhenD, _ref$inverse = _ref.inverse, inverse = _ref$inverse === void 0 ? false : _ref$inverse, _ref$isContentLabelle = _ref.isContentLabelledByTrigger, isContentLabelledByTrigger = _ref$isContentLabelle === void 0 ? false : _ref$isContentLabelle, rest = _objectWithoutProperties14(_ref, _excluded14);
  var inverseClassName = (0, import_dig_foundations4.useTheme)().getInverseProps().className;
  var cls = (0, import_classnames10.default)("dig-Menu", menuClassName, _defineProperty6({}, inverseClassName, inverse), className);
  var _useMaxMenuHeight = useMaxMenuHeight(hasMaxHeight), _useMaxMenuHeight2 = _slicedToArray4(_useMaxMenuHeight, 2), maxHeight = _useMaxMenuHeight2[0], setMaxMenuHeight = _useMaxMenuHeight2[1];
  var triggerRef = React16.useRef(null);
  var contentRef = React16.useRef(null);
  var contentOverlayRef = React16.useRef(null);
  var _useSubmenu = (0, import_hooks3.useSubmenu)(), closeActiveSubmenu = _useSubmenu.close, registerActiveSubmenu = _useSubmenu.register, hasActiveSubmenu = _useSubmenu.hasActiveSubmenu;
  var _useMenu = (0, import_hooks3.useMenu)({
    triggerRef: triggerRef,
    contentRef: contentRef,
    onSelection: onSelection,
    onToggle: onToggle,
    closeOnSelection: closeOnSelection,
    shouldFocusDisabledRows: shouldFocusDisabledRows,
    interactiveRowSelectors: INTERACTIVE_MENU_ROW_SELECTORS,
    delayFocus: slideSubmenu ? MENU_SLIDE_DURATION_MS : void 0,
    isContentLabelledByTrigger: isContentLabelledByTrigger
  }), isOpen = _useMenu.isOpen, openMenu = _useMenu.openMenu, closeMenu = _useMenu.closeMenu, toggleMenu = _useMenu.toggleMenu, value = _useMenu.value, setSelected = _useMenu.setSelected, setFocused = _useMenu.setFocused, getRootProps = _useMenu.getRootProps, getTriggerProps = _useMenu.getTriggerProps, getContentProps = _useMenu.getContentProps, menuRows = _useMenu.menuRows, focusTrigger = _useMenu.focusTrigger;
  React16.useEffect(function() {
    if (!isOpen) {
      closeActiveSubmenu({
        autoFocus: false
      });
    }
  }, [isOpen, closeActiveSubmenu]);
  var updateContent = React16.useCallback(function() {
    if (contentOverlayRef.current)
      contentOverlayRef.current.update();
  }, [contentOverlayRef]);
  var parentMenuContext = React16.useContext(MenuContext);
  var calculatedSlideSubmenu = _isSubmenu ? parentMenuContext.slideSubmenu : slideSubmenu;
  var closeMenuAndActiveSubmenu = React16.useCallback(function(options2) {
    if (contentRef && contentRef.current) {
      closeActiveSubmenu({});
      closeMenu(options2);
    }
  }, [closeMenu, closeActiveSubmenu, contentRef]);
  var defaultValue2 = {
    isPortaled: isPortaled,
    contentRef: contentRef,
    value: value,
    setSelected: setSelected,
    setFocused: setFocused,
    maxHeight: maxHeight,
    setMaxMenuHeight: setMaxMenuHeight,
    isSubmenu: _isSubmenu,
    hasActiveSubmenu: hasActiveSubmenu,
    topLevelTriggerRef: _isSubmenu ? parentMenuContext.topLevelTriggerRef : triggerRef,
    parentMenuContext: _isSubmenu ? parentMenuContext : void 0,
    menuRows: menuRows,
    registerActiveSubmenu: registerActiveSubmenu,
    closeActiveSubmenu: closeActiveSubmenu,
    closeMenu: closeMenu,
    hasMaxHeight: hasMaxHeight,
    shouldMatchContainerWidth: matchContainingWidth,
    slideSubmenu: calculatedSlideSubmenu,
    inverse: inverse,
    closeOnSelection: closeOnSelection
  };
  var options = {
    openMenu: openMenu,
    closeMenu: closeMenuAndActiveSubmenu,
    toggleMenu: toggleMenu,
    getTriggerProps: getTriggerProps,
    getContentProps: function(options2) {
      return _objectSpread6({
        ref: contentOverlayRef,
        open: Boolean(isOpen),
        triggerRef: triggerRef
      }, getContentProps(options2));
    },
    menuRows: menuRows,
    triggerRef: triggerRef,
    contentRef: contentRef,
    setSelected: setSelected
  };
  var handleClickOutside = React16.useCallback(function() {
    if (closeOnBlur) {
      closeMenuAndActiveSubmenu({
        ref: triggerRef,
        immediate: true
      });
    }
  }, [closeOnBlur, closeMenuAndActiveSubmenu, triggerRef]);
  var wrappedChildren = (
    // Only render the click outside container if this is a root menu
    !_isSubmenu ? /* @__PURE__ */ React16.createElement(
      import_click_outside.ClickOutside,
      {
        className: (0, import_classnames10.default)("dig-Menu-backdrop", menuBackdropClassName),
        isBlock: isBlock,
        onClickOutside: handleClickOutside,
        shouldPropagateMouseEvents: shouldPropagateClickOutsideMouseEvents,
        isClickThroughPortaled: isPortaled,
        isActive: Boolean(isOpen),
        shouldClickOutsideWhenDefaultPrevented: closeOnBlurWhenDefaultPrevented
      },
      children && children(options)
    ) : (
      // eslint-disable-next-line react-compiler/react-compiler
      children && children(options)
    )
  );
  React16.useImperativeHandle(ref, function() {
    return {
      focusTrigger: focusTrigger,
      updateContent: updateContent
    };
  }, [focusTrigger, updateContent]);
  return /* @__PURE__ */ React16.createElement(MenuContext.Provider, { value: defaultValue2 }, /* @__PURE__ */ React16.createElement("div", __spreadValues({ className: cls }, getRootProps(rest)), wrappedChildren));
});
Wrapper.displayName = "Wrapper";

// ../src/menu/submenu.tsx
function _objectDestructuringEmpty(obj) {
  if (obj == null)
    throw new TypeError("Cannot destructure " + obj);
}
var Submenu = function(_ref) {
  var id = _ref.id, withTriggerContent = _ref.withTriggerContent, withLeftAccessory = _ref.withLeftAccessory, withRightAccessory = _ref.withRightAccessory, _ref$auto = _ref.auto, auto = _ref$auto === void 0 ? true : _ref$auto, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "right-start" : _ref$placement, contentClassName = _ref.contentClassName, disabled = _ref.disabled, children = _ref.children, _ref$openDelay = _ref.openDelay, openDelay = _ref$openDelay === void 0 ? 0 : _ref$openDelay, triggerProps = _ref.triggerProps, contentProps = _ref.contentProps, onSubmenuOpened = _ref.onSubmenuOpened, onSubmenuClosed = _ref.onSubmenuClosed, closeOnSelection = _ref.closeOnSelection, _ref$motionProvider = _ref.motionProvider, motionProvider = _ref$motionProvider === void 0 ? MenuMotion : _ref$motionProvider;
  var triggerRef = React17.useRef(null);
  var triggerTimeout = React17.useRef();
  var invokeCloseCallback = React17.useRef(true);
  var _React$useContext = React17.useContext(MenuContext), menuRows = _React$useContext.menuRows, setSelected = _React$useContext.setSelected, registerActiveSubmenu = _React$useContext.registerActiveSubmenu, closeActiveSubmenu = _React$useContext.closeActiveSubmenu, isPortaled = _React$useContext.isPortaled, slideSubmenu = _React$useContext.slideSubmenu, topLevelTriggerRef = _React$useContext.topLevelTriggerRef, inverse = _React$useContext.inverse;
  var _React$useContext2 = React17.useContext(MenuContentContext), contentPlacement = _React$useContext2.placement, contentOffset = _React$useContext2.offset;
  var checkTimeout = function() {
    if (triggerTimeout.current) {
      clearTimeout(triggerTimeout.current);
      triggerTimeout.current = void 0;
    }
  };
  var handleSelection = function(value, evt) {
    var keepSubmenuOpen = closeOnSelection === false;
    setSelected(value, evt, {
      stayOpen: keepSubmenuOpen
    });
  };
  var onSubmenuContentOpened = React17.useCallback(function() {
    if (onSubmenuOpened) {
      onSubmenuOpened(id);
    }
  }, [id, onSubmenuOpened]);
  var openMenuWrapper = function(_ref2) {
    var openMenu = _ref2.openMenu, closeMenu = _ref2.closeMenu, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus;
    checkTimeout();
    invokeCloseCallback.current = false;
    closeActiveSubmenu();
    invokeCloseCallback.current = true;
    openMenu({
      autoFocus: autoFocus || slideSubmenu
    });
    registerActiveSubmenu(function(options) {
      var mergedOptions = options ? options : slideSubmenu ? {
        autoFocus: true,
        ref: triggerRef
      } : {
        autoFocus: false
      };
      closeMenuWrapper({
        closeMenu: closeMenu,
        options: mergedOptions
      });
    });
  };
  var closeMenuWrapper = function(_ref3) {
    var closeMenu = _ref3.closeMenu, options = _ref3.options;
    if (onSubmenuClosed && invokeCloseCallback.current) {
      onSubmenuClosed(id);
    }
    closeMenu(options || {});
  };
  var handleMouseLeave = function(evt) {
    checkTimeout();
    if (triggerProps && triggerProps.onMouseLeave) {
      triggerProps.onMouseLeave(evt);
    }
  };
  var createTriggerClick = function(_ref4) {
    var openMenu = _ref4.openMenu, closeMenu = _ref4.closeMenu, _ref4$autoFocus = _ref4.autoFocus, autoFocus = _ref4$autoFocus === void 0 ? false : _ref4$autoFocus;
    return function(evt) {
      if (disabled)
        return;
      evt.stopPropagation();
      openMenuWrapper({
        openMenu: openMenu,
        closeMenu: closeMenu,
        autoFocus: autoFocus
      });
    };
  };
  var createSlidingCloseSubMenuClick = function(_ref5) {
    _objectDestructuringEmpty(_ref5);
    return function() {
      closeActiveSubmenu();
    };
  };
  var createSlidingCloseSubMenuKeyDown = function(_ref6) {
    _objectDestructuringEmpty(_ref6);
    return function(evt) {
      switch (evt.key) {
        case ENTER_KEY:
          evt.stopPropagation();
          closeActiveSubmenu();
          break;
      }
    };
  };
  var createHandleMouseEnter = function(_ref7) {
    var openMenu = _ref7.openMenu, closeMenu = _ref7.closeMenu;
    return function(evt) {
      if (disabled)
        return;
      if (triggerTimeout.current)
        return;
      if (slideSubmenu)
        return;
      if (triggerProps && triggerProps.onMouseEnter) {
        triggerProps.onMouseEnter(evt);
      }
      var performOpen = function() {
        openMenuWrapper({
          openMenu: openMenu,
          closeMenu: closeMenu,
          autoFocus: false
        });
      };
      if (openDelay) {
        triggerTimeout.current = window.setTimeout(function() {
          performOpen();
        }, openDelay);
      } else {
        performOpen();
      }
    };
  };
  var createTriggerHandleKeyDown = function(_ref8) {
    var openMenu = _ref8.openMenu, closeMenu = _ref8.closeMenu;
    return function(evt) {
      if (disabled)
        return;
      if (triggerProps && triggerProps.onKeyDown) {
        triggerProps.onKeyDown(evt);
      }
      switch (evt.key) {
        case ENTER_KEY:
          evt.stopPropagation();
          openMenuWrapper({
            openMenu: openMenu,
            closeMenu: closeMenu,
            autoFocus: true
          });
          return;
        case RIGHT_ARROW_KEY:
          openMenuWrapper({
            openMenu: openMenu,
            closeMenu: closeMenu,
            autoFocus: true
          });
          return;
      }
    };
  };
  var createTriggerHandleKeyUp = function(_ref9) {
    var openMenu = _ref9.openMenu, closeMenu = _ref9.closeMenu;
    return function(evt) {
      if (triggerProps && triggerProps.onKeyUp) {
        triggerProps.onKeyUp(evt);
      }
      if (evt.key === SPACEBAR_KEY) {
        if (disabled)
          return;
        evt.stopPropagation();
        evt.preventDefault();
        openMenuWrapper({
          openMenu: openMenu,
          closeMenu: closeMenu,
          autoFocus: true
        });
      }
    };
  };
  var createContentHandleKeyUp = function(_ref10) {
    var menuRows2 = _ref10.menuRows;
    return function(evt) {
      if (contentProps && contentProps.onKeyUp) {
        contentProps.onKeyUp(evt);
      }
      if (evt.key === SPACEBAR_KEY && (0, import_hooks4.isFocusingMenuRow)(menuRows2.items, evt.target)) {
        evt.preventDefault();
      }
    };
  };
  var createContentHandleKeyDown = function(_ref11) {
    var menuRows2 = _ref11.menuRows, triggerRef2 = _ref11.triggerRef, closeMenu = _ref11.closeMenu;
    return function(evt) {
      if (contentProps && contentProps.onKeyDown) {
        contentProps.onKeyDown(evt);
      }
      switch (evt.key) {
        case TAB_KEY:
          evt.stopPropagation();
          closeMenuWrapper({
            closeMenu: closeMenu,
            options: {
              autoFocus: true,
              ref: triggerRef2
            }
          });
          return;
        case ESC_KEY:
          evt.stopPropagation();
          if (slideSubmenu) {
            closeMenuWrapper({
              closeMenu: closeMenu,
              options: {
                autoFocus: true,
                ref: topLevelTriggerRef,
                immediate: true
              }
            });
          } else {
            closeMenuWrapper({
              closeMenu: closeMenu,
              options: {
                autoFocus: true,
                ref: triggerRef2
              }
            });
          }
          return;
        case UP_ARROW_KEY:
          evt.stopPropagation();
          evt.preventDefault();
          var prevIndex = (0, import_hooks4.moveFocusBackward)(menuRows2.items, menuRows2.selectedIndex);
          (0, import_hooks4.focusItem)(menuRows2.items, prevIndex);
          menuRows2.setSelectedIndex(prevIndex);
          return;
        case DOWN_ARROW_KEY:
          evt.stopPropagation();
          evt.preventDefault();
          var nextIndex = (0, import_hooks4.moveFocusForward)(menuRows2.items, menuRows2.selectedIndex);
          (0, import_hooks4.focusItem)(menuRows2.items, nextIndex);
          menuRows2.setSelectedIndex(nextIndex);
          return;
        case LEFT_ARROW_KEY:
          evt.stopPropagation();
          evt.preventDefault();
          if (slideSubmenu) {
            closeActiveSubmenu();
          } else {
            closeMenuWrapper({
              closeMenu: closeMenu,
              options: {
                autoFocus: true,
                ref: triggerRef2
              }
            });
          }
          if (triggerRef2.current && "focus" in triggerRef2.current)
            triggerRef2.current.focus();
          return;
      }
    };
  };
  React17.useEffect(function() {
    return function() {
      if (triggerTimeout.current) {
        clearTimeout(triggerTimeout.current);
      }
    };
  }, []);
  return /* @__PURE__ */ React17.createElement(Wrapper, { className: (0, import_classnames11.default)("dig-Menu--submenu", submenuClassName), onSelection: handleSelection, isPortaled: isPortaled, slideSubmenu: slideSubmenu, shouldFocusDisabledRows: menuRows.shouldFocusDisabledRows, _isSubmenu: true, inverse: inverse, closeOnSelection: closeOnSelection }, function(_ref12) {
    var openMenu = _ref12.openMenu, closeMenu = _ref12.closeMenu, getContentProps = _ref12.getContentProps, getTriggerProps = _ref12.getTriggerProps, menuRows2 = _ref12.menuRows;
    return /* @__PURE__ */ React17.createElement(React17.Fragment, null, /* @__PURE__ */ React17.createElement(
      Row,
      __spreadProps(__spreadValues({
        id: id,
        interactive: true,
        disabled: disabled,
        withLeftAccessory: withLeftAccessory,
        withRightAccessory: withRightAccessory || /* @__PURE__ */ React17.createElement(import_dig_icons2.UIIcon, { src: import_assets2.ChevronRightLine, size: "small" }),
        _isSubmenuTrigger: true
      }, getTriggerProps(triggerProps)), {
        ref: triggerRef,
        onMouseEnter: createHandleMouseEnter({
          openMenu: openMenu,
          closeMenu: closeMenu
        }),
        onMouseLeave: handleMouseLeave,
        onKeyDown: createTriggerHandleKeyDown({
          openMenu: openMenu,
          closeMenu: closeMenu
        }),
        onKeyUp: createTriggerHandleKeyUp({
          openMenu: openMenu,
          closeMenu: closeMenu
        }),
        onClick: createTriggerClick({
          openMenu: openMenu,
          closeMenu: closeMenu
        })
      }),
      withTriggerContent
    ), !disabled && /* @__PURE__ */ React17.createElement(
      Content,
      __spreadProps(__spreadValues({}, getContentProps(contentProps)), {
        triggerRef: slideSubmenu ? topLevelTriggerRef : triggerRef,
        triggerOffset: slideSubmenu ? contentOffset : {
          crossAxis: -8
        },
        auto: auto,
        placement: slideSubmenu ? contentPlacement : placement,
        className: contentClassName,
        onKeyDown: createContentHandleKeyDown({
          menuRows: menuRows2,
          triggerRef: triggerRef,
          closeMenu: closeMenu
        }),
        onKeyUp: createContentHandleKeyUp({
          menuRows: menuRows2
        }),
        onContentOpened: onSubmenuContentOpened,
        motionProvider: motionProvider
      }),
      slideSubmenu && /* @__PURE__ */ React17.createElement(Segment, null, /* @__PURE__ */ React17.createElement(Row, { interactive: true, disabled: disabled, withLeftAccessory: /* @__PURE__ */ React17.createElement(import_dig_icons2.UIIcon, { src: import_assets2.ChevronLeftLine, size: "small" }), onClick: createSlidingCloseSubMenuClick({
        closeMenu: closeMenu
      }), onKeyDown: createSlidingCloseSubMenuKeyDown({
        closeMenu: closeMenu
      }) }, withTriggerContent)),
      children
    ));
  });
};
Submenu.displayName = "Submenu";

// ../src/menu/menu.ts
var Menu = {
  ActionItem: ActionItem,
  Canvas: Canvas,
  Content: Content,
  LinkItem: LinkItem,
  Row: Row,
  RowAccessory: RowAccessory,
  RowContent: RowContent,
  RowSubtitle: RowSubtitle,
  RowTitle: RowTitle,
  Segment: Segment,
  SelectItem: SelectItem,
  Submenu: Submenu,
  Wrapper: Wrapper
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BACKSPACE_KEY,
  DELETE_KEY,
  DOWN_ARROW_KEY,
  ENTER_KEY,
  ESC_KEY,
  FOCUSABLE_SELECTOR,
  LAST_SELECTED_INDEX,
  LEFT_ARROW_KEY,
  Menu,
  NONE_SELECTED_INDEX,
  RIGHT_ARROW_KEY,
  SPACEBAR_KEY,
  TAB_KEY,
  UP_ARROW_KEY,
  VISUALLY_HIDDEN_CSS,
  buttonContentDataAttributeName,
  buttonContentDataSelector,
  buttonDataAttributeName,
  buttonDataSelector,
  iconButtonDataAttributeName,
  iconButtonDataSelector,
  splitButtonDataAttributeName,
  splitButtonDataSelector
});
